//import { formatJsonLocation as fjl, formatLocation } from "../../components/renderers";
import { formatJsonLocation as fjl } from "../../components/renderers";
import { formatJsonDataset as fjd } from "../../components/renderers";

const xlsaccept = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel';
const csvaccept = 'text/csv'; //, .csv
const sheetaccept = `${xlsaccept},${csvaccept}`;

/*
fileuploads: {
    service: {
      name: 'fileupload',
      title: 'Upload File',
      key:'rid',
      num: false,
      fields: ['rid','fgi', 'fgn', 'fgc', 'hds','pms', 'rds', 'att', 'dcd', 'tot', 'fln', 'res', 'exi', 'sts', 'ast', 'stp'],
      params: {fgn:'Group',pgc:'Code',hds:'Headers',pms:'Parameters',rds:'Records',att:'Attachments',dcd:'Created',tot:'Total',fln:'Filename',res:'Resource',exi:'Extrainfo',sts:'Status'},
      grid: [['fgn','File Group'],['fgc','Code'],['dcd','Created'],['pms','Parameters'],['tot','Total'],['fln','Filename'],['exi','ExtraInfo'],['sts','Status'],['stp','Stamp']],
      bar: {pag:true,btn:['add','edit','del','view','man','wiz']},
      menu: {mnu:[{t:'Group',v:'fgn'},{t:'Code',v:'fgc'}],def:'fgn'},
      eform:[
        {id:'tki',label:'TrackID',type:'ai',req:0,ops:{},off:['edit','delete']},
        {id:'fgi',label:'File Group',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'filegroup'}},
        {id:'rfn',label:'Reference',type:'tf',req:1,ops:{},off:['edit','delete']},
        {id:'hds',label:'Headers',type:'jf',req:0,ops:{},off:['add','edit','delete']},
        {id:'pms',label:'Parameters',type:'jf',req:0,ops:{},off:['add','edit','delete']},
        {id:'rds',label:'Records',type:'jf',req:0,ops:{},off:['add','edit','delete']},
        {id:'att',label:'Attachments',type:'jf',req:0,ops:{},off:['add','edit','delete']},
        {id:'dcd',label:'Created',type:'df',req:0,ops:{},off:['add','edit','delete']},
        {id:'tot',label:'Total',type:'df',req:0,ops:{},off:['add','edit','delete']},
        {id:'fln',label:'File',type:'fu',req:0,ops:{preview:false,accept:xlsaccept}},
        {id:'res',label:'Resource',type:'df',req:0,ops:{},off:['add','edit','delete']},
        {id:'exi',label:'Extrainfo',type:'jf',req:0,ops:{}},
        {id:'rmk',label:'Remarks',type:'ta',req:0,ops:{}},
        {id:'sts',label:'Status',type:'fa',req:1,ops:{},cp:{t:'lcs',s:'status'}},
      ],
    },
    type: 'default',
    create:true,
    actions: {add:'Add',edit:'Edit',del:'Delete',delete:'Delete',view:'View'},
    panels: {add:'simple',edit:'simple',delete:'dialog',view:'simple'},
    formatters: {grid: {pms:fjd,res:fjd,exi:fjd}, form:{pms:fjd,res:fjd,exi:fjd}}
  },

  */

export const fileconfig = {
  upload: {
    service: {
      name: 'upload',
      title: 'File Upload',
      key:'rid',
      num: false,
      fields: ['rid','fgi', 'fgn', 'fgc', 'hds','pms', 'rds', 'att', 'dcd', 'tot', 'fln', 'res', 'exi', 'sts', 'ast', 'stp'],
      params: {fgn:'Group',pgc:'Code',hds:'Headers',pms:'Parameters',rds:'Records',att:'Attachments',dcd:'Created',tot:'Total',fln:'Filename',res:'Resource',exi:'Extrainfo',sts:'Status'},
      grid: [['gpn','File Group'],['gpc','Code'],['fln','Filename'],['tki','Track ID'],['dcd','Created'],['fds','Parameters'],['sts','Status'],['stp','Stamp']],
      bar: {pag:true,btn:['add','edit','del','view','man','wiz']},
      menu: {mnu:[{t:'Group',v:'fgn'},{t:'Code',v:'fgc'}],def:'fgn'},
      eform:[
        {id:'tki',label:'TrackID',type:'ai',req:0,ops:{},off:['edit','delete']},
        {id:'fgi',label:'File Group',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'filegroup'}},
        {id:'rfn',label:'Reference',type:'tf',req:1,ops:{},off:['edit','delete']},
        {id:'hds',label:'Headers',type:'jf',req:0,ops:{},off:['add','edit','delete']},
        {id:'pms',label:'Parameters',type:'jf',req:0,ops:{},off:['add','edit','delete']},
        {id:'rds',label:'Records',type:'jf',req:0,ops:{},off:['add','edit','delete']},
        {id:'att',label:'Attachments',type:'jf',req:0,ops:{},off:['add','edit','delete']},
        {id:'dcd',label:'Created',type:'df',req:0,ops:{},off:['add','edit','delete']},
        {id:'tot',label:'Total',type:'df',req:0,ops:{},off:['add','edit','delete']},
        {id:'fln',label:'File',type:'fu',req:0,ops:{preview:false,accept:xlsaccept}},
        {id:'res',label:'Resource',type:'df',req:0,ops:{},off:['add','edit','delete']},
        {id:'exi',label:'Extrainfo',type:'jf',req:0,ops:{}},
        {id:'rmk',label:'Remarks',type:'ta',req:0,ops:{}},
        {id:'sts',label:'Status',type:'fa',req:1,ops:{},cp:{t:'lcs',s:'status'}},
      ],
    },
    create:false,
    actions: {delete:'Delete',view:'View'},
    panels: {add:'simple',edit:'simple',delete:'dialog',view:'simple'},
    formatters: {grid: {pms:fjd,res:fjd,exi:fjd}, form:{pms:fjd,res:fjd,exi:fjd}}
  },

  sheet: {
    service: {
      name: 'file',
      title: 'Upload Sheets',
      key:'rid',
      num: false,
      fields: ['rid','fgi', 'fgn', 'fgc', 'hds','pms', 'rds', 'att', 'dcd', 'tot', 'fln', 'res', 'exi', 'sts', 'ast', 'stp'],
      params: {fgn:'Group',pgc:'Code',hds:'Headers',pms:'Parameters',rds:'Records',att:'Attachments',dcd:'Created',tot:'Total',fln:'Filename',res:'Resource',exi:'Extrainfo',sts:'Status'},
      grid: [['fgn','File Group'],['fgc','Code'],['dcd','Created'],['pms','Parameters'],['tot','Total'],['fln','Filename'],['exi','ExtraInfo'],['sts','Status'],['stp','Stamp']],
      bar: {pag:true,btn:['add','edit','del','view','man','wiz']},
      menu: {mnu:[{t:'Group',v:'fgn'},{t:'Code',v:'fgc'}],def:'fgn'},
      eform:[{id:'fgi',label:'File Group',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'filegroup'}},
            {id:'hds',label:'Headers',type:'jf',req:0,ops:{},off:['add','edit','delete']},
            {id:'pms',label:'Parameters',type:'jf',req:0,ops:{},off:['add','edit','delete']},
            {id:'rds',label:'Records',type:'jf',req:0,ops:{},off:['add','edit','delete']},
            {id:'att',label:'Attachments',type:'jf',req:0,ops:{},off:['add','edit','delete']},
            {id:'dcd',label:'Created',type:'df',req:0,ops:{},off:['add','edit','delete']},
            {id:'tot',label:'Total',type:'df',req:0,ops:{},off:['add','edit','delete']},
            //{id:'fln',label:'File',type:'fu',req:0,ops:{preview:false,accept:xlsaccept}},
            {id:'res',label:'Resource',type:'df',req:0,ops:{},off:['add','edit','delete']},
            {id:'exi',label:'Extrainfo',type:'jf',req:0,ops:{}},
            {id:'sts',label:'Status',type:'fa',req:1,ops:{},cp:{t:'lcs',s:'status'}},
          ],
    },
    create:false,
    actions: {add:'Add',edit:'Edit',del:'Delete',delete:'Delete',view:'View'},
    panels: {add:'simple',edit:'simple',delete:'dialog',view:'simple'},
    formatters: {grid: {pms:fjd,res:fjd,exi:fjd}, form:{pms:fjd,res:fjd,exi:fjd}}
  },
  file: {
    service: {
      name: 'file',
      title: 'File',
      key:'rid',
      num: false,
      fields: ['rid','fgi', 'fgn', 'fgc', 'hds','pms', 'rds', 'att', 'dcd', 'tot', 'fln', 'res', 'exi', 'sts', 'ast', 'stp'],
      params: {fgn:'Group',pgc:'Code',hds:'Headers',pms:'Parameters',rds:'Records',att:'Attachments',dcd:'Created',tot:'Total',fln:'Filename',res:'Resource',exi:'Extrainfo',sts:'Status'},
      grid: [['gpn','File Group'],['gpc','Code'],['dcd','Created'],['rfn','Reference'],['fds','Total'],['fln','Filename'],['sts','Status'],['stp','Stamp']],
      bar: {pag:true,btn:['add','edit','del','view','man','wiz']},
      menu: {mnu:[{t:'Group',v:'fgn'},{t:'Code',v:'fgc'}],def:'fgn'},
      eform:[{id:'fgi',label:'File Group',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'filegroup'}},
            {id:'hds',label:'Headers',type:'jf',req:0,ops:{},off:['add','edit','delete']},
            {id:'pms',label:'Parameters',type:'jf',req:0,ops:{},off:['add','edit','delete']},
            {id:'rds',label:'Records',type:'jf',req:0,ops:{},off:['add','edit','delete']},
            {id:'att',label:'Attachments',type:'jf',req:0,ops:{},off:['add','edit','delete']},
            {id:'dcd',label:'Created',type:'df',req:0,ops:{},off:['add','edit','delete']},
            {id:'tot',label:'Total',type:'df',req:0,ops:{},off:['add','edit','delete']},
            //{id:'fln',label:'File',type:'fu',req:0,ops:{preview:false,accept:xlsaccept}},
            {id:'res',label:'Resource',type:'df',req:0,ops:{},off:['add','edit','delete']},
            {id:'exi',label:'Extrainfo',type:'jf',req:0,ops:{}},
            {id:'sts',label:'Status',type:'fa',req:1,ops:{},cp:{t:'lcs',s:'status'}},
          ],
    },
    create:false,
    actions: {add:'Add',edit:'Edit',del:'Delete',delete:'Delete',view:'View'},
    panels: {add:'simple',edit:'simple',delete:'dialog',view:'simple'},
    formatters: {grid: {pms:fjd,res:fjd,exi:fjd}, form:{pms:fjd,res:fjd,exi:fjd}}
  },
  filemap: {
    service: {
      name: 'filemap',
      title: 'File Map',
      key:'rid',
      num: false,
      fields: ['rid','fgi', 'fgn', 'fgc', 'hds','pms', 'rds', 'att', 'dcd', 'tot', 'fln', 'res', 'exi', 'sts', 'ast', 'stp'],
      params: {fgn:'Group',pgc:'Code',hds:'Headers',pms:'Parameters',rds:'Records',att:'Attachments',dcd:'Created',tot:'Total',fln:'Filename',res:'Resource',exi:'Extrainfo',sts:'Status'},
      grid: [['fln','File Name'],['acc','Activity'],['sts','Status']],
      bar: {pag:true,btn:['add','edit','del','view','man','wiz']},
      menu: {mnu:[{t:'Group',v:'fgn'},{t:'Code',v:'fgc'}],def:'fgn'},
      eform:[
            {id:'fli',label:'File',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'file'}},
            {id:'aci',label:'Activity',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'activity'}},
            {id:'sts',label:'Status',type:'fa',req:1,ops:{},cp:{t:'lcs',s:'status'}},
          ],
    },
    create:false,
    actions: {add:'Add',edit:'Edit',del:'Delete',delete:'Delete',view:'View'},
    panels: {add:'simple',edit:'simple',delete:'dialog',view:'simple'},
    formatters: {grid: {pms:fjd,res:fjd,exi:fjd}, form:{pms:fjd,res:fjd,exi:fjd}}
  },
  filemeta: {
    service: {
      name: 'filemeta',
      title: 'File Meta',
      key:'rid',
      num: false,
      fields: ['rid','fgi', 'fgn', 'fgc', 'hds','pms', 'rds', 'att', 'dcd', 'tot', 'fln', 'res', 'exi', 'sts', 'ast', 'stp'],
      params: {fgn:'Group',pgc:'Code',hds:'Headers',pms:'Parameters',rds:'Records',att:'Attachments',dcd:'Created',tot:'Total',fln:'Filename',res:'Resource',exi:'Extrainfo',sts:'Status'},
      grid: [['rnm','Form Name'],['rco','Code'],['rty','Type'],['rma','Mask'],['sts','Status'],],
      bar: {pag:true,btn:['add','edit','del','view','man','wiz']},
      menu: {mnu:[{t:'Group',v:'fgn'},{t:'Code',v:'fgc'}],def:'fgn'},
      eform:[{id:'rno',label:'File No',type:'tf',req:1,ops:{}},
            {id:'rnm',label:'File Name',type:'tf',req:1,ops:{}},
            {id:'rco',label:'File Code',type:'tf',req:1,ops:{}},
            {id:'rlb',label:'Label',type:'tf',req:1,ops:{},},
            {id:'rty',label:'Type',type:'tf',req:1,ops:{},},
            {id:'rma',label:'Mask',type:'nf',req:1,ops:{},},
            {id:'rds',label:'Description',type:'tf',req:0,ops:{},},
            {id:'sts',label:'Status',type:'fa',req:1,ops:{},cp:{t:'lcs',s:'status'}},
          ],
    },
    create:true,
    actions: {add:'Add',edit:'Edit',del:'Delete',delete:'Delete',view:'View'},
    panels: {add:'simple',edit:'simple',delete:'dialog',view:'simple'},
    formatters: {grid: {pms:fjd,res:fjd,exi:fjd}, form:{pms:fjd,res:fjd,exi:fjd}}
  },
  filehistory: {
    service: {
      name: 'filehistory',
      title: 'File History',
      key:'rid',
      num: false,
      fields: ['rid','fgi', 'fgn', 'fgc', 'hds','pms', 'rds', 'att', 'dcd', 'tot', 'fln', 'res', 'exi', 'sts', 'ast', 'stp'],
      params: {fgn:'Group',pgc:'Code',hds:'Headers',pms:'Parameters',rds:'Records',att:'Attachments',dcd:'Created',tot:'Total',fln:'Filename',res:'Resource',exi:'Extrainfo',sts:'Status'},
      grid: [['fln','File Name'],['rco','Form No'],['rcd','Records'],['rmk','Remarks'],['dcd','Date Created'],['sts','Status'],],
      bar: {pag:true,btn:['add','edit','del','view','man','wiz']},
      menu: {mnu:[{t:'Group',v:'fgn'},{t:'Code',v:'fgc'}],def:'fgn'},
      eform:[{id:'fgi',label:'File Group',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'filegroup'}},
            {id:'hds',label:'Headers',type:'jf',req:0,ops:{},off:['add','edit','delete']},
            {id:'pms',label:'Parameters',type:'jf',req:0,ops:{},off:['add','edit','delete']},
            {id:'rds',label:'Records',type:'jf',req:0,ops:{},off:['add','edit','delete']},
            {id:'att',label:'Attachments',type:'jf',req:0,ops:{},off:['add','edit','delete']},
            {id:'dcd',label:'Created',type:'df',req:0,ops:{},off:['add','edit','delete']},
            {id:'tot',label:'Total',type:'df',req:0,ops:{},off:['add','edit','delete']},
            //{id:'fln',label:'File',type:'fu',req:0,ops:{preview:false,accept:xlsaccept}},
            {id:'res',label:'Resource',type:'df',req:0,ops:{},off:['add','edit','delete']},
            {id:'exi',label:'Extrainfo',type:'jf',req:0,ops:{}},
            {id:'sts',label:'Status',type:'fa',req:1,ops:{},cp:{t:'lcs',s:'status'}},
          ],
    },
    create:false,
    actions: {add:'Add',edit:'Edit',del:'Delete',delete:'Delete',view:'View'},
    panels: {add:'simple',edit:'simple',delete:'dialog',view:'simple'},
    formatters: {grid: {pms:fjd,res:fjd,exi:fjd}, form:{pms:fjd,res:fjd,exi:fjd}}
  },

  form: {
    service: {
      name: 'form',
      title: 'Forms',
      key:'rid',
      num: false,
      fields: ['rid','fgi', 'fgn', 'fgc', 'hds','pms', 'rds', 'att', 'dcd', 'tot', 'fln', 'res', 'exi', 'sts', 'ast', 'stp'],
      params: {fgn:'Group',pgc:'Code',hds:'Headers',pms:'Parameters',rds:'Records',att:'Attachments',dcd:'Created',tot:'Total',fln:'Filename',res:'Resource',exi:'Extrainfo',sts:'Status'},
      grid: [['frn','File Name'],['enn','Entity'],['fid','File ID'],['acn','Activity'],['vno','Verno'],['dsc','Description'],['dcd','Date Created'],['sts','Status'],],
      bar: {pag:true,btn:['add','edit','del','view','man','wiz']},
      menu: {mnu:[{t:'Group',v:'fgn'},{t:'Code',v:'fgc'}],def:'fgn'},
      eform:[{id:'fgi',label:'File Group',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'filegroup'}},
            {id:'hds',label:'Headers',type:'jf',req:0,ops:{},off:['add','edit','delete']},
            {id:'pms',label:'Parameters',type:'jf',req:0,ops:{},off:['add','edit','delete']},
            {id:'rds',label:'Records',type:'jf',req:0,ops:{},off:['add','edit','delete']},
            {id:'att',label:'Attachments',type:'jf',req:0,ops:{},off:['add','edit','delete']},
            {id:'dcd',label:'Created',type:'df',req:0,ops:{},off:['add','edit','delete']},
            {id:'tot',label:'Total',type:'df',req:0,ops:{},off:['add','edit','delete']},
            //{id:'fln',label:'File',type:'fu',req:0,ops:{preview:false,accept:xlsaccept}},
            {id:'res',label:'Resource',type:'df',req:0,ops:{},off:['add','edit','delete']},
            {id:'exi',label:'Extrainfo',type:'jf',req:0,ops:{}},
            {id:'sts',label:'Status',type:'fa',req:1,ops:{},cp:{t:'lcs',s:'status'}},
          ],
    },
    create:false,
    actions: {delete:'Delete',view:'View'},
    panels: {add:'simple',edit:'simple',delete:'dialog',view:'simple'},
    formatters: {grid: {pms:fjd,res:fjd,exi:fjd}, form:{pms:fjd,res:fjd,exi:fjd}}
  },

  formmeta: {
    service: {
      name: 'formmeta',
      title: 'Form Meta',
      key:'rid',
      num: false,
      fields: ['rid','fgi', 'fgn', 'fgc', 'hds','pms', 'rds', 'att', 'dcd', 'tot', 'fln', 'res', 'exi', 'sts', 'ast', 'stp'],
      params: {fgn:'Group',pgc:'Code',hds:'Headers',pms:'Parameters',rds:'Records',att:'Attachments',dcd:'Created',tot:'Total',fln:'Filename',res:'Resource',exi:'Extrainfo',sts:'Status'},
      grid: [['rnm','Form Name'],['rco','Code'],['rty','Type'],['rma','Mask'],['sts','Status'],],
      bar: {pag:true,btn:['add','edit','del','view','man','wiz']},
      menu: {mnu:[{t:'Group',v:'fgn'},{t:'Code',v:'fgc'}],def:'fgn'},
      eform:[{id:'rno',label:'Form No',type:'tf',req:1,ops:{}},
            {id:'rnm',label:'Form Name',type:'tf',req:1,ops:{}},
            {id:'rco',label:'Form Code',type:'tf',req:1,ops:{}},
            {id:'rlb',label:'Label',type:'tf',req:1,ops:{},},
            {id:'rty',label:'Type',type:'tf',req:1,ops:{},},
            {id:'rma',label:'Mask',type:'nf',req:1,ops:{},},
            {id:'rds',label:'Description',type:'tf',req:0,ops:{},},
            {id:'sts',label:'Status',type:'fa',req:1,ops:{},cp:{t:'lcs',s:'status'}},
          ],
    },
    create:true,
    actions: {delete:'Delete',view:'View'},
    panels: {add:'simple',edit:'simple',delete:'dialog',view:'simple'},
    formatters: {grid: {pms:fjd,res:fjd,exi:fjd}, form:{pms:fjd,res:fjd,exi:fjd}}
  },
  formhistory: {
    service: {
      name: 'formhistory',
      title: 'Form History',
      key:'rid',
      num: false,
      fields: ['rid','fgi', 'fgn', 'fgc', 'hds','pms', 'rds', 'att', 'dcd', 'tot', 'fln', 'res', 'exi', 'sts', 'ast', 'stp'],
      params: {fgn:'Group',pgc:'Code',hds:'Headers',pms:'Parameters',rds:'Records',att:'Attachments',dcd:'Created',tot:'Total',fln:'Filename',res:'Resource',exi:'Extrainfo',sts:'Status'},
      grid: [['tag','Tag'],['acc','Activity'],['fln','File'],['vno','Verno'],['dsc','Description'],['dcd','Date Created'],['sts','Status'],],
      bar: {pag:true,btn:['add','edit','del','view','man','wiz']},
      menu: {mnu:[{t:'Group',v:'fgn'},{t:'Code',v:'fgc'}],def:'fgn'},
      eform:[{id:'fgi',label:'File Group',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'filegroup'}},
            {id:'hds',label:'Headers',type:'jf',req:0,ops:{},off:['add','edit','delete']},
            {id:'pms',label:'Parameters',type:'jf',req:0,ops:{},off:['add','edit','delete']},
            {id:'rds',label:'Records',type:'jf',req:0,ops:{},off:['add','edit','delete']},
            {id:'att',label:'Attachments',type:'jf',req:0,ops:{},off:['add','edit','delete']},
            {id:'dcd',label:'Created',type:'df',req:0,ops:{},off:['add','edit','delete']},
            {id:'tot',label:'Total',type:'df',req:0,ops:{},off:['add','edit','delete']},
            //{id:'fln',label:'File',type:'fu',req:0,ops:{preview:false,accept:xlsaccept}},
            {id:'res',label:'Resource',type:'df',req:0,ops:{},off:['add','edit','delete']},
            {id:'exi',label:'Extrainfo',type:'jf',req:0,ops:{}},
            {id:'sts',label:'Status',type:'fa',req:1,ops:{},cp:{t:'lcs',s:'status'}},
          ],
    },
    create:false,
    actions: {delete:'Delete',view:'View'},
    panels: {add:'simple',edit:'simple',delete:'dialog',view:'simple'},
    formatters: {grid: {pms:fjd,res:fjd,exi:fjd}, form:{pms:fjd,res:fjd,exi:fjd}}
  },
  formmap: {
    service: {
      name: 'formmap',
      title: 'Form Map',
      key:'rid',
      num: false,
      fields: ['rid','fgi', 'fgn', 'fgc', 'hds','pms', 'rds', 'att', 'dcd', 'tot', 'fln', 'res', 'exi', 'sts', 'ast', 'stp'],
      params: {fgn:'Group',pgc:'Code',hds:'Headers',pms:'Parameters',rds:'Records',att:'Attachments',dcd:'Created',tot:'Total',fln:'Filename',res:'Resource',exi:'Extrainfo',sts:'Status'},
      grid: [['tag','Tag'],['fln','File Name'],['acc','Activity'],['dsc','Description'],['sts','Status']],
      bar: {pag:true,btn:['add','edit','del','view','man','wiz']},
      menu: {mnu:[{t:'Group',v:'fgn'},{t:'Code',v:'fgc'}],def:'fgn'},
      eform:[{id:'tag',label:'Tag',type:'tf',req:1,ops:{}},
            {id:'fli',label:'File',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'file'}},
            {id:'aci',label:'Activity',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'activity'}},
            {id:'dsc',label:'Description',type:'tf',req:0,ops:{},},
            {id:'sts',label:'Status',type:'fa',req:1,ops:{},cp:{t:'lcs',s:'status'}},
          ],
    },
    create:true,
    actions: {delete:'Delete',view:'View'},
    panels: {add:'simple',edit:'simple',delete:'dialog',view:'simple'},
    formatters: {grid: {pms:fjd,res:fjd,exi:fjd}, form:{pms:fjd,res:fjd,exi:fjd}}
  },
  formmetamap: {
    service: {
      name: 'formmetamap',
      title: 'Form Meta Map',
      key:'rid',
      num: false,
      fields: ['rid','fgi', 'fgn', 'fgc', 'hds','pms', 'rds', 'att', 'dcd', 'tot', 'fln', 'res', 'exi', 'sts', 'ast', 'stp'],
      params: {fgn:'Group',pgc:'Code',hds:'Headers',pms:'Parameters',rds:'Records',att:'Attachments',dcd:'Created',tot:'Total',fln:'Filename',res:'Resource',exi:'Extrainfo',sts:'Status'},
      grid: [['tag','Tag'],['fln','File Name'],['acc','Activity'],['dsc','Description'],['sts','Status'],],
      bar: {pag:true,btn:['add','edit','del','view','man','wiz']},
      menu: {mnu:[{t:'Group',v:'fgn'},{t:'Code',v:'fgc'}],def:'fgn'},
      eform:[{id:'tag',label:'Tag',type:'tf',req:1,ops:{}},
            {id:'fli',label:'File',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'file'}},
            {id:'aci',label:'Activity',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'activity'}},
            {id:'dsc',label:'Description',type:'tf',req:0,ops:{},},
            {id:'msk',label:'Mask Number',type:'nf',req:0,ops:{}},
            {id:'sts',label:'Status',type:'fa',req:1,ops:{},cp:{t:'lcs',s:'status'}},
          ],
    },
    create:true,
    actions: {delete:'Delete',view:'View'},
    panels: {add:'simple',edit:'simple',delete:'dialog',view:'simple'},
    formatters: {grid: {pms:fjd,res:fjd,exi:fjd}, form:{pms:fjd,res:fjd,exi:fjd}}
  },
  formrequest: {
    service: {
      name: 'formrequest',
      title: 'Form Request',
      key:'rid',
      num: false,
      fields: ['rid','fgi', 'fgn', 'fgc', 'hds','pms', 'rds', 'att', 'dcd', 'tot', 'fln', 'res', 'exi', 'sts', 'ast', 'stp'],
      params: {fgn:'Group',pgc:'Code',hds:'Headers',pms:'Parameters',rds:'Records',att:'Attachments',dcd:'Created',tot:'Total',fln:'Filename',res:'Resource',exi:'Extrainfo',sts:'Status'},
      grid: [['tag','Tag'],['ctc','Customer Type'],['itc','Customer Type'],['idn','Customer ID No'],['prd','Product'],['rno','Reference'],['dcd','Requested at'],['xpr','Expires at'],],
      bar: {pag:true,btn:['add','edit','del','view','man','wiz']},
      menu: {mnu:[{t:'Group',v:'fgn'},{t:'Code',v:'fgc'}],def:'fgn'},
      eform:[{id:'fgi',label:'File Group',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'filegroup'}},
            {id:'hds',label:'Headers',type:'jf',req:0,ops:{},off:['add','edit','delete']},
            {id:'pms',label:'Parameters',type:'jf',req:0,ops:{},off:['add','edit','delete']},
            {id:'rds',label:'Records',type:'jf',req:0,ops:{},off:['add','edit','delete']},
            {id:'att',label:'Attachments',type:'jf',req:0,ops:{},off:['add','edit','delete']},
            {id:'dcd',label:'Created',type:'df',req:0,ops:{},off:['add','edit','delete']},
            {id:'tot',label:'Total',type:'df',req:0,ops:{},off:['add','edit','delete']},
            //{id:'fln',label:'File',type:'fu',req:0,ops:{preview:false,accept:xlsaccept}},
            {id:'res',label:'Resource',type:'df',req:0,ops:{},off:['add','edit','delete']},
            {id:'exi',label:'Extrainfo',type:'jf',req:0,ops:{}},
            {id:'sts',label:'Status',type:'fa',req:1,ops:{},cp:{t:'lcs',s:'status'}},
          ],
    },
    create:false,
    actions: {delete:'Delete',view:'View'},
    panels: {add:'simple',edit:'simple',delete:'dialog',view:'simple'},
    formatters: {grid: {pms:fjd,res:fjd,exi:fjd}, form:{pms:fjd,res:fjd,exi:fjd}}
  },

}
